import * as React from 'react';

var DEFAULT_NAV_CTA = 'Order now';
var NavigationCTAContext = React.createContext({
    hideOrderNowLink: false,
    navigationCta: 'Order now',
    navigationCtaPath: '/testing-options',
});

export { DEFAULT_NAV_CTA, NavigationCTAContext };
//# sourceMappingURL=NavigationCtaContext.esm.js.map
